import { render } from "./RequestDocumentsModal.vue?vue&type=template&id=154629f4&scoped=true"
import script from "./RequestDocumentsModal.vue?vue&type=script&lang=js"
export * from "./RequestDocumentsModal.vue?vue&type=script&lang=js"

import "./RequestDocumentsModal.vue?vue&type=style&index=0&id=154629f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154629f4"]])

export default __exports__